import React from 'react'
import ReactDOM from 'react-dom'
import 'react-app-polyfill/stable'
import { Buffer } from 'buffer'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@coreui/coreui/dist/css/coreui.min.css'
import './styles.scss'
import App from './App'
import { UIProvider } from './shared/ui/UIProvider'

window.Buffer = window.Buffer || Buffer

ReactDOM.render(
  <React.StrictMode>
    <UIProvider>
      <App />
    </UIProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)
